var React = require('react');

function Copy (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#818A91","fillRule":"evenodd"},[React.createElement("path",{"d":"M10.442 3.137H2.267c-.767 0-1.39.636-1.39 1.418V16.52c0 .782.623 1.418 1.39 1.418h8.175c.767 0 1.39-.636 1.39-1.418V4.555c-.003-.782-.626-1.418-1.39-1.418zm.414 13.379a.422.422 0 0 1-.417.426H2.263a.422.422 0 0 1-.417-.426V4.556c0-.236.187-.427.417-.427h8.176c.23 0 .417.191.417.426v11.96z","key":0}),React.createElement("path",{"d":"M13.568 0H5.393c-.767 0-1.39.636-1.39 1.418a.49.49 0 0 0 .486.496.49.49 0 0 0 .486-.496c0-.235.188-.426.418-.426h8.175c.23 0 .418.19.418.426v11.964a.422.422 0 0 1-.418.427.49.49 0 0 0-.486.495.49.49 0 0 0 .486.496c.767 0 1.39-.635 1.39-1.418V1.418c0-.782-.623-1.418-1.39-1.418z","key":1})]));
}

Copy.defaultProps = {"width":"15","height":"18","viewBox":"0 0 15 18"};

module.exports = Copy;

Copy.default = Copy;



// WEBPACK FOOTER //
// ./src/Assets/Icons/copy.svg